import React from 'react';
import SearchField from './components/SearchField';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import style from './DevicesControlPanel.module.scss';

const DevicesControlPanel: React.FC = () => {
	return (
		<div data-test="DevicesControlPanel">
			<div className={style.firstRowWithControls}>
				<SearchField />
			</div>
			<div className={style.secondRowWithControls}>
				<SortBy />
				<CountOfItem />
			</div>
		</div>
	);
};

export default DevicesControlPanel;
